import { useParams } from 'react-router-dom';
import { useContainer } from 'unstated-next';

import { ClassDetail } from './ClassDetail';
import { ClassProvider } from '../../../../../context/ClassContext';
import { ClassContainer } from '../../../../ClassModal/ClassContainer';
import AdminAuthContainer from '../../../AdminAuthContainer';

const ClassWithAdminDetails = (props: { classUuid: string }) => {
    const { classUuid } = props;
    const { canManageClasses: hasAdminPrivileges } = useContainer(AdminAuthContainer);

    return (
        <ClassProvider classUuid={classUuid} hasAdminPrivileges={hasAdminPrivileges}>
            <ClassDetail />
        </ClassProvider>
    );
};

export const ClassPage = () => {
    const { classUuid } = useParams<{ classUuid: string }>();
    return (
        <ClassContainer.Provider>
            <AdminAuthContainer.Provider>
                <ClassWithAdminDetails classUuid={classUuid} />
            </AdminAuthContainer.Provider>
        </ClassContainer.Provider>
    );
};
